//🇫🇷
const frFloorList = {
    RoomFloorList_RDC: 'RDC',
    RoomFloorList_RDC_Long: 'Rez de chaussée',
    RoomFloorList_Etage1a3: '1er au 3ème étage',
    RoomFloorList_4etPlus: '4ème étage et plus',
    RoomFloorList_Floor: 'étage',

    StairsFloorList_RDC: 'du rdc au 1er étage',//!\\(facturation rdc livraison)
    StairsFloorList_RDC_Description: '(facturation rdc livraison)',
    StairsFloorList_Etage1a2: 'du 1er étage au 2e étage',
    StairsFloorList_Etage2a3: 'du 2e étage au 3e étage',
    StairsFloorList_Etage3a4: '3e étage au 4e etage',
    StairsFloorList_Etage4etPlus: '4e etage et plus',
    // SI 4e etage et plus, mettre commentaire libre pour préciser l’étage (à remettre en synthèse)
}

const frOpeningTypes = {
    Opening_Door: 'Porte',
    Opening_ArmoredDoor: 'Porte blindée',
    Opening_FrenchDoor: 'Porte fenêtre',
    Opening_FrontDoor: "Porte d'entrée",
    Opening_PatioDoor: 'Baie vitrée',
    Opening_opening: 'Passage ouvert',
}

const frRoomItemTypes = {
    //* ROOM ITEMS - SOL
    RoomItem_ShowerBathtub: 'Douche / Baignoire',
    RoomItem_FixedFurniture: 'Meuble non déplaçable',
    RoomItem_Cupboard: 'Placard',
    RoomItem_KitchenFurniture: 'Meuble de cuisine',
    RoomItem_Trap: 'Trappe',
    RoomItem_Fireplace: 'Cheminée',
    RoomItem_Opening: 'Ouverture',
    RoomItem_Stairs: 'Marche',
    RoomItem_Divider: 'Cloison',
    RoomItem_HeavyElement: 'Élément lourd (jaccuzi, pot fleur...)',
    RoomItem_SewerPlate: 'Regard, plaque égout',

    //* ROOM ITEMS - WALL
    RoomItem_Door: 'Porte',
    RoomItem_Window: 'Fenêtre',
    RoomItem_UnlaidArea: 'Zone non posée',
}

const frRoomTypeList = {
    RoomTypeList_ChambreDressing: 'Chambre / Dressing',
    RoomTypeList_Bureau: 'Bureau',
    RoomTypeList_Salon: 'Salon',
    RoomTypeList_SalleManger: 'Salle à manger',
    RoomTypeList_Cuisine: 'Cuisine',
    RoomTypeList_WC: 'WC',
    RoomTypeList_SalleEau: "Salle d'eau ou salle de bain",
    RoomTypeList_Buanderie: 'Buanderie',
    RoomTypeList_Veranda: 'Veranda',
    RoomTypeList_HallEntree: 'Hall / entrée',
    RoomTypeList_Couloir: 'Couloir',
    RoomTypeList_Garage: 'Garage',
    RoomTypeList_TerasseCouvert: 'Terrasse sous abri',
    RoomTypeList_TerasseNonCouvert: 'Terrasse non couverte',
    RoomTypeList_Balcon: 'Balcon',
    RoomTypeList_BordPiscinePlat: 'Bord de piscine plat',
    RoomTypeList_BordPiscineIncline: 'Bord de piscine incliné',
    RoomTypeList_Jardin: 'Jardin',
    RoomTypeList_LocalProIndividuel: 'Local professionnel individuel',
    RoomTypeList_PartieCommuneCoPro: "Parties communes d'une co-propriété",
    RoomTypeList_LocalProCollectif: 'Local professionnel collectif',
    RoomTypeList_ChambreHotel: "Chambre d'hotel",
    RoomTypeList_Boutique: 'Boutique',
    RoomTypeList_LieuTresFrequente: 'Lieu très fréquenté',
    RoomTypeList_Industrie: 'Industrie',
    RoomTypeList_Evenementiel: 'Évènementiel',
    RoomTypeList_Ascenseur: 'Ascenseur',
    RoomTypeList_AutresPartiesCommunes: 'Autres parties communes',
    RoomTypeList_Cour: 'Cour',
    RoomTypeList_ToitTerrasseAvecEtanchéite: 'Toit terrasse avec étanchéité',
    RoomTypeList_GraviersEnrobes: 'Graviers / enrobés',
    RoomTypeList_StructureBoisMetal: 'Structure (Bois, métal)',
}

const frRoomCurrentFlooringList = {
    RoomCurrentFlooringList_Beton: 'Béton (Fondation dalle brute)',
    RoomCurrentFlooringList_Ciment: 'Ciment (chape ou ragréage)',
    RoomCurrentFlooringList_PlancherBois: 'Plancher en bois',
    RoomCurrentFlooringList_BétonPeintCire: 'Béton peint ou ciré',
    RoomCurrentFlooringList_ChapeSeche: 'Chape sèche (plaque de rénovation)',
    RoomCurrentFlooringList_Terre: 'Terre',
    RoomCurrentFlooringList_ParquetColle: 'Parquet collé',
    RoomCurrentFlooringList_ParquetStratifieNonColle: 'Parquet ou stratifié non collé',

    RoomCurrentFlooringList_Carrelage: 'Carrelage',
    RoomCurrentFlooringList_Moquette: 'Moquette',
    RoomCurrentFlooringList_RevetementPlastique: 'Plastique (vinyle, lino, dalle, gazon)',
    RoomCurrentFlooringList_TerasseBoisComposite: 'Terrasse bois ou composite',
    RoomCurrentFlooringList_Paves: 'Pavés',

    RoomCurrentFlooringList_Peinture: 'Peinture',
    RoomCurrentFlooringList_PapierPeint: 'Papier peint',
    RoomCurrentFlooringList_Crepis: 'Crepis',
    RoomCurrentFlooringList_Lambris: 'Lambris',
    RoomCurrentFlooringList_MoquetteMurale: 'Moquette murale',
    RoomCurrentFlooringList_VinyleMural: 'Vinyle mural',

    RoomCurrentFlooringList_PlacoPlatreCiment: 'Placo / Plâtre / Ciment',
    RoomCurrentFlooringList_Beton_Wall: 'Béton',
    RoomCurrentFlooringList_Bois: 'Bois',
    RoomCurrentFlooringList_Pierre: 'Pierre',
    RoomCurrentFlooringList_Parpaing: 'Parpaing',

    //STAIR
    RoomCurrentFlooringList_EscalierEnBois: 'Escalier en bois',//!\\ SANS REVETEMENT
    RoomCurrentFlooringList_EscalierEnBeton: 'Escalier en béton',//!\\ SANS REVETEMENT
    RoomCurrentFlooringList_EscalierEnMetal: 'Escalier en métal',//!\\ SANS REVETEMENT
    RoomCurrentFlooringList_EscalierRecouvertMoquette: 'Recouvert de moquette ou vinyle',//!\\ AVEC REVETEMENT
    RoomCurrentFlooringList_EscalierRecouvertParquet: 'Recouvert de parquet ou stratifié',//!\\ AVEC REVETEMENT
    RoomCurrentFlooringList_EscalierRecouvertPassageEscalier: "Recouvert de passage d'escalier",//!\\ AVEC REVETEMENT
    RoomCurrentFlooringList_EscalierRecouvertCarrelage: 'Recouvert de carrelage',//!\\ AVEC REVETEMENT
}

const frRoomHeatingTypeList = {
    RoomHeatingTypeList_PasDeChauffage: "Je n'ai pas de chauffage au sol",
    RoomHeatingTypeList_BasseTemperatureEau: 'Basse T° à eau (<28°)',
    RoomHeatingTypeList_BasseTemperatureAccumulation: 'Basse T° à accumulation (<28°)',
    RoomHeatingTypeList_HauteTemperature: 'Haute température (>28°)',
    RoomHeatingTypeList_ElectriqueRayonnant: 'Électrique rayonnant',
    RoomHeatingTypeList_Reversible: 'Réversible',
    RoomHeatingTypeList_SystemeRapporte: 'Système rapporté',
    RoomHeatingTypeList_UnknownType: 'Je ne connais pas le type de chauffage au sol',
}

const frRoomWallTypeList = {
    RoomWallTypeList_Mur: 'Mur',
    RoomWallTypeList_Credence: 'Crédence',
    RoomWallTypeList_TablierBaignoire: 'Tablier baignoire',
}

const frOpeningTypeList = {
    //* OUVERTURE SOL
    Floorplan_Opening_door: 'Porte',
    Floorplan_Opening_armored_door: 'Porte blindée',
    Floorplan_Opening_front_door: "Porte d'entrée",
    Floorplan_Opening_french_door: 'Porte fenêtre',
    Floorplan_Opening_patio_door: 'Baie vitrée',
    Floorplan_Opening_opening: 'Passage ouvert',
}

const frRoomElementTypeList = {
    //* AMENAGEMENT SOL
    Floorplan_RoomElement_shower_bathtub: 'Douche / Baignoire',
    Floorplan_RoomElement_fixed_furniture: 'Meuble non déplaçable',
    Floorplan_RoomElement_cupboard: 'Placard',
    Floorplan_RoomElement_kitchen_furniture: 'Meuble de cuisine',
    Floorplan_RoomElement_trap: 'Trappe',
    Floorplan_RoomElement_fireplace: 'Cheminée',
    Floorplan_RoomElement_opening: 'Ouverture',
    Floorplan_RoomElement_stairs: 'Marche',
    Floorplan_RoomElement_divider: 'Cloison',
}

const frWallElementTypeList = {
    //* OUVERTURE - WALL
    Floorplan_RoomElement_door: 'Porte',
    Floorplan_RoomElement_window: 'Fenêtre',
    Floorplan_RoomElement_unlaid_area: 'Zone non posée',
}

//* CONTOURNEMENTS : rename : like Opening_Contournement_Pillar
const frContournements = {
    // CONTOURNEMENTS : SOL
    Contournement_MountedRadiator: 'Radiateur {br}sur pied',
    Contournement_MountedElement: 'Element {br}sur pied',
    Contournement_Pillar: 'Pilier /{br}obstacle',
    Contournement_Stonewall: 'Murs en pierres{br}apparentes ou{br}arrondis',
    Contournement_Stairs: 'Escalier',
    Contournement_Pipe: 'Tuyau au sol',
    Contournement_Railing: 'Rambarde',
    Contournement_Tree: 'Arbre',

    //* CONTOURNEMENTS : WALL
    Contournement_WallPipe: 'Tuyau filant /{br}gaine',
    Contournement_WallPipeHole: 'Trou tuyau',
    Contournement_ElectricEquipment: 'Equipement{br}électrique',
    Contournement_WallPillar: 'Pilier /{br}obstacle',
    Contournement_Hotspot: 'Point chaud',
}

export const frMapElementDictionnary = {
    ...frFloorList,
    ...frOpeningTypes,
    ...frRoomItemTypes,
    ...frRoomTypeList,
    ...frRoomCurrentFlooringList,
    ...frRoomHeatingTypeList,
    ...frRoomWallTypeList,
    ...frOpeningTypeList,
    ...frRoomElementTypeList,
    ...frWallElementTypeList,
    ...frContournements
}